<script>
export default {
    props: {
        active: {type: Boolean, default: false},
    },

    computed: {
        css() {
            return this.active ? 'fas fa-bookmark' : 'far fa-bookmark'
        }
    }
}
</script>

<template>
  <button class="btn btn-sm navbar-btn btn-secondary me-1 mb-1"
  v-b-tooltip.hover title="Zeige Favoriten"
   @click.prevent="$emit('click')">
       <i :class="css"></i>
  </button>
</template>
